import { render, staticRenderFns } from "./CarCard.vue?vue&type=template&id=0b776fa0&scoped=true"
import script from "./CarCard.vue?vue&type=script&lang=ts"
export * from "./CarCard.vue?vue&type=script&lang=ts"
import style0 from "./CarCard.vue?vue&type=style&index=0&id=0b776fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b776fa0",
  null
  
)

export default component.exports